import React from 'react';
import Skeleton from "../Skeleton/Skeleton";
import ContentPanel from "../ContentPanel/ContentPanel";

const footer = () => {
    return (
            <ContentPanel
                    skeleton={<Skeleton type="MAIN_PANEL"/>}
                    errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                    templateUrl={"./content/home/page-components/text-block/footer.html"}
            />
    )
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js